import bbox from '@turf/bbox';
import { lineString } from '@turf/helpers';
import { useEffect, useMemo } from 'react';
import { COLOR_MAP_POI, COLOR_MAP_POI_OUTLINE } from '@alltrails/denali/tokens';
import type { POISearchResult, TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import useMap from '../../../hooks/useMap';
import type { LngLat } from '../../../types/Geo';
import { decodeSegmentLngLat } from '../../../utils/legacyGeoJSONConversions';
import { Polylines } from '../../Polyline';
import POIPinLarge from '../POIPinLarge';

const FocusedPOIComponents = ({
  poi,
  trails,
  onPinClick,
  shouldOrientMapAroundPolylines,
  shouldHidePhoto
}: {
  poi?: POISearchResult;
  trails: TrailSearchResult[];
  onPinClick?: () => void;
  shouldOrientMapAroundPolylines?: boolean;
  shouldHidePhoto?: boolean;
}) => {
  const map = useMap();
  const polylines = useMemo<{ coordinates: LngLat[]; properties?: Record<string, any> }[]>(() => {
    return trails.reduce<{ coordinates: LngLat[]; properties?: Record<string, any> }[]>((accPolylines, result) => {
      if (!result.polyline) {
        return accPolylines;
      }
      const coordinates = decodeSegmentLngLat({ polyline: { pointsData: result.polyline } }) as LngLat[];
      return [...accPolylines, { coordinates, properties: { trailId: result.ID } }];
    }, []);
  }, [trails]);

  useEffect(() => {
    if (shouldOrientMapAroundPolylines && polylines && map) {
      const mapBBox = bbox(lineString(polylines.map(polyline => polyline.coordinates).flat()));
      map.fitBounds([mapBBox[0], mapBBox[1], mapBBox[2], mapBBox[3]]);
    }
  }, [polylines, map, shouldOrientMapAroundPolylines]);

  return (
    <>
      <POIPinLarge id="focused-poi" onClick={onPinClick} poi={poi?.type === 'poi' ? poi : undefined} shouldHidePhoto={shouldHidePhoto} />
      {poi && <Polylines lineColor={COLOR_MAP_POI} lineOutlineColor={COLOR_MAP_POI_OUTLINE} polylines={polylines} uniqueId="poi-focused-polylines" />}
    </>
  );
};

export default FocusedPOIComponents;
